import logoWhiteLogistician from "@/assets/logoWithName-white-color-logistician.svg";
import logoWhiteMerchant from "@/assets/logoWithName-white-color-merchant.svg";
import logoWhiteOther from "@/assets/logoWithName-white-color-other.svg";
import logoWitheStore from "@/assets/logoWithName-white-color-store.svg";
import logoWhiteSuperAdmin from "@/assets/logoWithName-white-color-superadmin.svg";
import { useViewerIsSuperAdmin } from "@/lib/rights/use-viewer-is-baback-team";
import useViewerRole from "@/lib/rights/use-viewer-role.ts";

export default function SidebarLogo() {
  const role = useViewerRole();
  const isSuperAdmin = useViewerIsSuperAdmin();

  if (!role) return null;

  // Red, subtitled "Super admin", whatever the shop role (BAB-3035).
  if (isSuperAdmin) {
    return (
      <div className="py-2">
        <img
          className="h-8 w-auto"
          src={logoWhiteSuperAdmin}
          alt="Baback Super admin"
        />
      </div>
    );
  }

  const logo = {
    owner: logoWhiteMerchant,
    admin: logoWhiteMerchant,
    store: logoWitheStore,
    customersupport: logoWhiteOther,
    logistician: logoWhiteLogistician,
  }[role];

  return (
    <div className="py-2">
      <img className="h-8 w-auto" src={logo} alt="Workflow" />
    </div>
  );
}
